// extracted by mini-css-extract-plugin
export default {"story-card":"App_story-card__LnKLE"};